<div class="app-header-band">
  <div class="govuk-width-container">
    <div class="d-flex">
        <gb-ui-header
            [imageDetail]="imageDetail"
            [showSearch]="false"
            [navLinks]="navigation"
          >
          <ng-template #utilityArea>
            <div class="d-flex">
              @if (!isAdmin()) {
              <button class="btn btn-primary login" (click)="login()">
                Log in
              </button>
              }
            </div>
          </ng-template>
        </gb-ui-header>
    </div>
  </div>
</div>
